import { Options } from 'react-use-websocket'

// WEBSOCKETS DISABLED: Reservoir's realtime websocket API is discontinued.
// This hook is kept as a no-op so call sites (useTokenUpdateStream, collection
// pages) keep working without opening dead socket connections. Live updates
// now come from SWR polling against the server-side Alchemy translation layer.
export default (_chainId: number, _options: Options = {}) => {
  return {
    sendMessage: (..._args: any[]) => {},
    sendJsonMessage: (..._args: any[]) => {},
    lastMessage: null,
    lastJsonMessage: null,
    readyState: 3, // CLOSED
    getWebSocket: () => null,
  }
}
